export default __webpack_public_path__ + "static/media/card6.690ea7e9.svg";